export const FellowConstants = {
    NOT_ON_LIST: '97F6AE51-09B9-46A5-92A2-C32CA5C9E074'.toLowerCase(),
};